const HTTP_API = {
    // 获取联系人列表
    getRepaymentInfo:{
        method:'post',
        url:'api/h5App/repayment/h5-key'
    },
    getExtensionInfo:{
        method:'post',
        url:'api/h5App/extension/h5-key'
    },
    
    pointH5Report:{
        method:'post',
        url:'api/h5App/repayment/h5-report'
    },
    getOrderList:{
        method:'get',
        url:'api/h5App/orderList/h5-key'
    },
    repaymentBankChange:{
        method:'post',
        url:'api/bank/repaymentBankChangeByH5Key'
    },
    repaymentBankSupport:{
        method:'get',
        url:'api/bank/repayment/bank/support'
    },
    repaymentUrl:{
        method:'get',
        url:'api/h5App/repayment/h5-repaymentUrl'
    },
    repaymentMethod:{
        method:'get',
        url:'api/h5App/repaymentMethod/h5-key'
    },
     submitUrl:{
        method:'post',
        url:'api/h5App/submitUtr'
    },
}
export default HTTP_API;